module.exports = __webpack_public_path__ + "img/dgitem3.cb3c5178.png";